import React from 'react';
import { Link } from 'react-router-dom';

const SessionTimeout = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center p-6 bg-white rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Session Timed Out</h1>
        <p className="text-gray-700 mb-6">
          Your session has expired due to inactivity or an invalid token. Please sign in again to continue.
        </p>
        <Link
          to="/sign-in"
          className="inline-block px-6 py-2 bg-indigo-600 text-white font-semibold rounded-md hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        >
          Go to Sign In
        </Link>
      </div>
    </div>
  );
};

export default SessionTimeout;